<script setup>
import { getUser } from "@/services/api/auth.js";
import { getCurrentInstance } from "vue";
import { urlDoAdmin } from "@/services/sso.js";
const { appContext } = getCurrentInstance();
const APP_NAME = appContext.config.globalProperties.APP_NAME;
const APP_VERSION = appContext.config.globalProperties.version;
/**
 * Quem esta logado -- ou `null`, que E um estado possivel.
 *
 * `getUser()` le o `credentials` do localStorage, que so existe depois do
 * handoff de sessao gravar. Um cabecalho que estoura quando ele ainda nao
 * gravou derruba a aplicacao inteira: o erro sobe pelo render e a tela fica na
 * splash para sempre. Foi o que acontecia no primeiro login de um navegador
 * limpo.
 *
 * O `app.js` passou a esperar o router antes de montar, o que evita o
 * cabecalho aparecer na /sso. Isto aqui e o cinto: uma pessoa nao carregada
 * deve deixar o cabecalho sem nome, nunca derrubar a pagina.
 */
const user = getUser() ?? {};
const linkDoAdmin = urlDoAdmin("/home");
const version = APP_NAME + " " + APP_VERSION;

defineOptions({
    name: "AdminProfile",
});
</script>

<template>
    <v-menu>
        <template v-slot:activator="{ props }">
            <button class="profile-btn align-items-center" v-bind="props">
                <i class="material-symbols-outlined profile-btn__avatar"
                    >account_circle</i
                >
                <span class="fw-semibold text-black">{{
                    user?.name ?? ""
                }}</span>
            </button>
        </template>
        <v-list class="profile-menu-dropdown">
            <div class="admin d-flex align-items-center">
                <div>
                    <span
                        v-if="user?.fullname"
                        class="d-block text-black fw-medium text-capitalize"
                    >
                        {{ user.fullname }}
                    </span>
                </div>
            </div>
            <ul class="list pl-0 mt-0 mb-0 list-unstyled">
                <li v-if="linkDoAdmin">
                    <a :href="linkDoAdmin" class="d-block position-relative">
                        <i class="material-symbols-outlined">apps</i>
                        {{ $t("common.labels.backToAdmin") }}
                    </a>
                </li>
                <li>
                    <router-link to="/logout" class="d-block position-relative">
                        <i class="material-symbols-outlined">logout </i>
                        {{ $t("common.topHeader.logout") }}
                    </router-link>
                </li>
                <div class="border-top"></div>
                <span class="text-light ml-5 font-size-12">{{ version }}</span>
            </ul>
        </v-list>
    </v-menu>
</template>
